import React from "react";
import { Outlet } from "react-router";

 // eslint-disable-next-line
export default () => (
  <main className="mx-auto">
    <Outlet />
  </main>
);
